module.exports = __webpack_public_path__ + "media/images/pic/magazine-5fba5f74ed163c7a29bea8d61dd941f3.png";